import React, { Component } from 'react'
import styled from 'styled-components'
import { CtaBtn } from '../../../components'
import CheckIcon from '../../../lib/assets/icons/check-status.svg'
import SpinningIcon from '../../../lib/assets/icons/spinning-circles.svg'

import {
  verifyEMRAppts,
  verifyEMRNotes
} from '../../../rest'

// verifyEMRAppts
export const HEALTH_FAIL = {
  NOTE: 'We were not able to confirm access to your EHR profile. The Suki team will work with you to resolve this. In the meantime, you can continue without EHR linking.',
  APPOINTMENT: 'We weren\'t quite able to fully communicate with your EHR, but don\'t worry. The Suki team will work with you to resolve this. In the meantime, you can continue without EHR linking.',
  BYPASS_EMR: 'The Suki team will work with you to resolve this. In the meantime, you can continue without EHR linking.'
}

const HEALTH_STATUS = {
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
}

// appointmentCheck, noteCheck from rest
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;

    a {
        color: #006264;
    }

`
const Title = styled.h3`
    color: #000000;
    font-size: 26px;
    text-align:center;
    font-weight: 400;
`

const Checks = styled.div`
    margin-bottom: 20px;
`

const SuccessRow = styled.div`
    width: 100%;
    font-size: 20px;
    margin: 10px 0;
`

const SuccessIcon = styled.img.attrs({
  src: CheckIcon
})`
    width: 30px;
    margin: 0px;
    padding: 0;
    position: relative;
    top: 10px;    
    `

const LoadingIcon = styled.img.attrs({
  src: SpinningIcon
})`
    width: 30px;
    margin: 0px;
    padding: 0;
    position: relative;
    top: 5px;
    right: 8px;
    `

const ErrorTitle = styled.h3`
  font-size: 24px;
  text-align: center;
  font-weight: 600;
`

export const HealthCheckBase = ({ failType, handleContinue }) => {
  return (
    <Container>
      <ErrorTitle>{HEALTH_FAIL[failType]}</ErrorTitle>
      <CtaBtn handleClick={handleContinue}>Continue without EHR Linking</CtaBtn>
    </Container>
  )
}

class EHRCheck extends Component {
  state = {
    appointmentCheckStatus: HEALTH_STATUS.LOADING, // loading, success, error
    noteCheckStatus: HEALTH_STATUS.LOADING

  }

  async componentDidMount () {
    const { bypassEMR } = this.props
    if (bypassEMR) { return }

    await this.checkApptStatus()
  }

  checkApptStatus = () => {
    const { email, organizationId, emr, user, sukiUserId, emrUser, token } = this.props
    const emrApptCheckInputs = {
      email,
      token,
      organizationId,
      emrType: emr?.type,
      users: [{
        sukiUserId: sukiUserId,
        emrUserId: emrUser?.emrUserId,
        emrDepartmentId: emrUser?.emrDepartmentId,
        timezone: user?.timezone,
        emrUserIdList: [emrUser?.emrUserId]
      }],
      daysBeforeNow: 14,
      daysAfterNow: 28
    }

    return verifyEMRAppts(emrApptCheckInputs).then(res => {
      const { success } = res
      const appointmentCheckStatus = success ? HEALTH_STATUS.SUCCESS : HEALTH_STATUS.ERROR
      this.setState({ appointmentCheckStatus })
    }).catch(err => {
      this.setState({ appointmentCheckStatus: HEALTH_STATUS.ERROR })
      console.error(err)
    })
  }

  checkNoteStatus = () => {
    const { email, organizationId, emr, user, emrUser, token } = this.props

    const emrNoteCheckInputs = {
      email,
      token,
      organizationId,
      emrType: emr?.type,
      emrUser: [{
        sukiUserId: user?.id,
        emrUserId: emrUser?.emrUserId,
        emrDepartmentId: emrUser?.emrDeparementId,
        timezone: user?.timezone,
        emrUserIdList: [emrUser?.emrUserId]
      }]
    }
    return verifyEMRNotes(emrNoteCheckInputs).then(res => {
      const { success } = res
      const noteCheckStatus = success ? HEALTH_STATUS.SUCCESS : HEALTH_STATUS.ERROR
      this.setState({ noteCheckStatus })
    }).catch(err => {
      this.setState({ noteCheckStatus: HEALTH_STATUS.ERROR })
      console.error(err)
    })
  }

  onContinue = () => {
    const { handleFinishedChecks } = this.props
    handleFinishedChecks()
  }

  render () {
    const { bypassEMR } = this.props
    const { appointmentCheckStatus } = this.state
    const showContinueButton = appointmentCheckStatus === HEALTH_STATUS.SUCCESS

    if (bypassEMR) {
      return <HealthCheckBase failType='BYPASS_EMR' handleContinue={this.onContinue} />
    }

    if (appointmentCheckStatus === HEALTH_STATUS.ERROR) {
      const failType = appointmentCheckStatus === HEALTH_STATUS ? 'APPOINTMENT' : 'NOTE'
      return <HealthCheckBase failType={failType} handleContinue={this.onContinue} />
    }

    return (
      <Container>
        <Title>Thank you for confirming your EHR profile. <br /> We will now perform a final check to confirm that Suki is ready to go:</Title>

        <Checks>
          <SuccessRow>
            {appointmentCheckStatus === HEALTH_STATUS.SUCCESS && <SuccessIcon />}
            {appointmentCheckStatus === HEALTH_STATUS.LOADING && <LoadingIcon />}
            {appointmentCheckStatus === HEALTH_STATUS.LOADING ? 'Connecting to schedule...' : 'Connected to schedule'}
          </SuccessRow>
        </Checks>

        {showContinueButton && <CtaBtn handleClick={this.onContinue}>Continue</CtaBtn>}
      </Container>
    )
  }
}

export default EHRCheck
